
import { Spin } from "antd";
import { FC } from "react";
import "./assets.less";
import AssetsOverview from "./AssetsOverview";
import ChainAssetsItem from "./ChainAssetsItem";
import { ChainAssets } from "./AssetsInterfaces"

interface IProps {
    isFetching: boolean;
    chainsNumber: number;
    tokensNumber: number;
    bridgesNumber: number;
    chainAssetsList: ChainAssets[];
}

const Assets: FC<IProps> = (props: IProps) => {
    const { isFetching, chainsNumber, tokensNumber, bridgesNumber, chainAssetsList} = props

    return (
        <Spin spinning={isFetching} >
            <div className="assets">
            <div className="assets-title">
                <div className="assets-title-text">
                    Assets
                </div>
            </div>
            <div className="assets-content">
                <AssetsOverview chainsNumber={chainsNumber} tokensNumber={tokensNumber} bridgesNumber={bridgesNumber}/>
                <div className="assets-content-items">
                    {
                        chainAssetsList.map(item => {
                            return <ChainAssetsItem chainAssets={item} key={item.chain.id}/>
                        })
                    }
                </div> 
            </div>
        </div>
        </Spin>  
    )
}

export default Assets;